import { hasValue, styles } from "@repo/helpers";
import { CanvasHTMLAttributes, useEffect, useMemo, useRef, useState } from "react";

import { Button } from "../button";
import { InputComponent } from "../input";
import SignatureCanvas from "./signature";
import style from "./style.module.scss";
import { Props } from "./types";

export function Signature(props: Props) {
	const { ...inputProps } = props;
	const { id, value, disabled, changeHandler } = inputProps;
	const signatureRef = useRef<SignatureCanvas>();
	//If component initialized with existing signature, display as image
	const [fromSaved, setFromSaved] = useState(() => hasValue(value));

	const [width, height] = useMemo(() => {
		const fullWidth = document.getElementById("root").offsetWidth;
		if (!fullWidth) return [250, 75];
		let newWidth = fullWidth < 600 ? 250 : fullWidth * 0.7; //*.7 so don't overrun page padding etc
		if (newWidth > 1000) newWidth = 1000;
		return [newWidth, newWidth * 0.3].map(Math.round);
	}, []);

	function setInputComponentRef(ref: any) {}

	useEffect(() => {
		setTimeout(() => initialize(), 100);
	}, []);

	useEffect(() => {
		if (!value && signatureRef.current) clear();
	}, [value]);

	useEffect(() => {
		if (!signatureRef.current) return;
		if (disabled) signatureRef.current.off();
		else signatureRef.current.on();
	}, [disabled, fromSaved]);

	function initialize() {
		if (!fromSaved) {
			if (signatureRef.current) signatureRef.current.clear();
			else setTimeout(() => initialize(), 50);
		}
	}

	function clear() {
		setFromSaved(false);
		if (signatureRef.current) signatureRef.current.clear();
		changeHandler(null, id);
	}

	function onStrokeEnd() {
		if (!value) {
			//Only update if greater than min length (kind of arbitrarily determined here)
			const points = signatureRef.current.getSignaturePad().toData();
			if (points.flat(2).length < 5) return;
		}
		const signature = signatureRef.current.toDataURL("image/jpeg");
		changeHandler(signature, id);
	}

	const canvasProps = {
		className: styles(style.canvas, disabled && style.disabled),
		height: height,
		width: width,
	} as CanvasHTMLAttributes<HTMLCanvasElement>;
	return (
		<InputComponent {...inputProps} setRef={setInputComponentRef}>
			{renderSignature()}
			<Button onClick={clear} size="small">
				Clear
			</Button>
		</InputComponent>
	);

	function renderSignature() {
		if (fromSaved) return <img src={String(value)} className={style.canvas} alt="signature" />;
		return (
			<SignatureCanvas
				onEnd={onStrokeEnd}
				ref={signatureRef}
				canvasProps={canvasProps}
				clearOnResize={false}
				backgroundColor="white"
			/>
		);
	}
}
